package org.example.project.service

import androidx.compose.runtime.mutableStateMapOf
import org.example.project.utils.All

object KontaktKalenderPopupService {

    private val popupsByNode = mutableStateMapOf<String, List<All>>()

    private val templates = mutableStateMapOf<String, All>()
    private val callbacks = mutableMapOf<String, (All) -> Unit>()
    fun bookingTemplate(id: String): All? = templates[id]
    fun bookingCallback(id: String): ((All) -> Unit)? = callbacks[id]

    fun getPopups(node: String): List<All> = popupsByNode[node] ?: emptyList()

    fun openPopup(
        node: String,
        art: String,
        userId: String,
        firmenId: String,
        label: String,
        bookingTemplate: All? = null,
        onBookingSaved: ((All) -> Unit)? = null
    ): String {
        if (node.isBlank() || art.isBlank() || userId.isBlank()) return ""
        val popup = All(
            id = "kontakt-kalender-${js("Date.now()") as Double}",
            key = "KontaktKalenderPopup",
            label = label,
            art = art,
            bereich = node,
            userName = userId,
            firmenId = firmenId
        )
        bookingTemplate?.let { templates[popup.id] = it }
        onBookingSaved?.let { callback -> callbacks[popup.id] = { saved -> callback(saved); closePopup(node, popup.id) } }
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()) + popup
        return popup.id
    }

    fun closePopup(node: String, id: String) {
        templates.remove(id)
        callbacks.remove(id)
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()).filterNot { it.id == id }
    }
}
